import type {ReactElement} from 'react';
import {Text, TextSize, TextType} from '@Components/text';
import {Button, ButtonSize, ButtonType, IconPlacement} from '@Components/button';
import {StockPanelMessage} from '@Panels/stock-panel/components/stock-panel-message/stock-panel-message';
import type {StockPanelErrorProps} from './stock-panel-error.types';

function StockPanelError({...props}: StockPanelErrorProps): ReactElement {
  const getRefreshButton = (): ReactElement | null => {
    if (!props.onRefresh) {
      return null;
    }
    return (
      <Button type={ButtonType.SECONDARY} size={ButtonSize.MEDIUM} icon="icon-refresh" iconPlacement={IconPlacement.LEFT} text={window.i18next.t('pmwjs_refresh')} onClick={props.onRefresh} />
    );
  };

  return (
    <StockPanelMessage icon="icon-exclamation-triangle" className={props.className}>
      <Text className="content-body text-center" val={props.text} type={TextType.BODY} size={TextSize.MD} />
      {getRefreshButton()}
    </StockPanelMessage>
  );
}

export default StockPanelError;
